import React, { PureComponent } from 'react'
import { Link, NavLink, Redirect, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { logoutUser, fetchWaitingCount } from '../../actions'
import RoleControlled from '../_common/RoleControlled'

// import logo from '../../assets/img/img_logo.png'
import logo from '../../assets/img/logo.png'

class SideNav extends PureComponent {
  componentDidMount = () => {
    this.props.fetchWaitingCount()
  }

  _handleLogout = () => {
    this.props.logoutUser(this.props.history)
    return <Redirect to="/" />
  }
  render () {
    return (
      <aside className="flex column">
        <Link className="logo_container text-center" to="/">
          <img className="logo_img" src={logo} alt="Buffalo IT Solutionsのロゴ"/>
        </Link>
        <nav>
          <ul className="nav_list">
            <RoleControlled role={this.props.user.user_role} acceptedRoles={[0]}>
              <li className="dropdown_list">
                <input type="checkbox" id="toggleDropdown"/>
                <label htmlFor="toggleDropdown" className="flex align-center">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-add">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="12" y1="8" x2="12" y2="16"></line>
                    <line x1="8" y1="12" x2="16" y2="12"></line>
                  </svg>
                  <span>新規登録</span>
                  <svg className="icon icon-caret-down" viewBox="0 0 16 28">
                    <path d="M16 11c0 0.266-0.109 0.516-0.297 0.703l-7 7c-0.187 0.187-0.438 0.297-0.703 0.297s-0.516-0.109-0.703-0.297l-7-7c-0.187-0.187-0.297-0.438-0.297-0.703 0-0.547 0.453-1 1-1h14c0.547 0 1 0.453 1 1z"></path>
                  </svg>
                </label>
                <div className="dropdown_content">
                  <ul>
                    <li>
                      <Link to="/owners/add/owner">オーナー追加</Link>
                    </li>
                    <li>
                      <Link to="/owners/add/agency">管理会社追加</Link>
                    </li>
                    <li>
                      <Link to="/owners/1/property/add" className="add_property">BITS物件追加</Link>
                    </li>
                  </ul>
                </div>
              </li>
            </RoleControlled>

            <RoleControlled role={this.props.user.user_role} acceptedRoles={[0]}>
              <li className="home">
                <NavLink to="/" exact>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon_home">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                  <span>ホーム</span>
                </NavLink>
              </li>
            </RoleControlled>

            <RoleControlled role={this.props.user.user_role} acceptedRoles={[0]}>
              <li>
                <NavLink to="/owners">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon_owner">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  <span>管理会社・オーナー</span>
                </NavLink>
              </li>
            </RoleControlled>
            <li>
              <NavLink to="/properties">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 28" className="icon_property">
                  <path d="M6 20.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM6 16.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM10 16.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM6 12.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM18 20.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM14 16.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM10 12.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM6 8.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM18 16.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM14 12.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM10 8.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM6 4.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM18 12.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM14 8.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM10 4.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM18 8.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM14 4.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM18 4.5v1c0 0.266-0.234 0.5-0.5 0.5h-1c-0.266 0-0.5-0.234-0.5-0.5v-1c0-0.266 0.234-0.5 0.5-0.5h1c0.266 0 0.5 0.234 0.5 0.5zM14 26h6v-24h-18v24h6v-3.5c0-0.266 0.234-0.5 0.5-0.5h5c0.266 0 0.5 0.234 0.5 0.5v3.5zM22 1v26c0 0.547-0.453 1-1 1h-20c-0.547 0-1-0.453-1-1v-26c0-0.547 0.453-1 1-1h20c0.547 0 1 0.453 1 1z"></path>
                </svg>
                <span>物件</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/residents">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon_resident">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <span>入居者</span>
              </NavLink>
            </li>
            <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
              <li key="push">
                <NavLink to="/push">
                  <svg viewBox="0 0 24 24" className="icon_notifications">
                    <path d="M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0"></path>
                  </svg>
                  <span>お知らせ（Push通知）</span>
                </NavLink>
              </li>
            </RoleControlled>
            <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
              <li key="chat">
                {
                  this.props.chat.waitingCount > 0
                    ? <div className="badge">{this.props.chat.waitingCount}</div>
                    : null
                }
                <NavLink to="/chat" exact>
                  <svg viewBox="0 0 24 24" className="icon_chat">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                  <span>メッセージ（チャット）</span>
                </NavLink>
              </li></RoleControlled>
          </ul>
        </nav>
        <div className="user_container">
          {
            Number(this.props.user.user_role) === 1
              ? (
                <Link className="owner username flex align-center" to={`/owners/${this.props.user.owner_id}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  <span>{this.props.user.name}</span>
                </Link>
              )
              : (
                <div className="username flex align-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  <span>
                    {
                      Number(this.props.user.user_role) === 0
                        ? 'App-me! Cloud'
                        : 'ゲスト'
                    }
                  </span>
                </div>
              )
          }
          <div className="logout flex align-center" onClick={this._handleLogout}>
            <svg xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-log-out">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span>ログアウト</span>
          </div>
        </div>
      </aside>
    )
  }
}

// export default SideNav
function mapStateToProps ({ user, chat }) {
  return { user, chat }
}

export default withRouter(connect(mapStateToProps, { logoutUser, fetchWaitingCount })(SideNav))



// WEBPACK FOOTER //
// ./src/components/SideNav/index.js